export const WIDTH_COLLAPSE_OPEN = '13rem';
export const WIDTH_COLLAPSE_CLOSE = '4rem';
